import { TSobReportSalesType } from 'legacy/lut/components/widgets/public/partner360/configs/reports'

import { Nullable } from 'cng-common/models/utils'
import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'

import { getActualsCYQNetNdpField } from '../../getActualsCYQField'
import { getSobQField } from '../../getSobQField'
import { getSumOfNumbers } from '../../getSumOfNumbers'

interface IParams {
  data: ISobAnalyticsReportJoined[]
  quarters: number[]
  revenueField: 'Actuals' | 'Plans' | 'ExpExit'
  sobField: 'Actual' | 'Plan' | 'ExpExit'
  netNdp: TSobReportSalesType
}

export const calculateDisplayRevenueForPeriod = ({
  data,
  quarters,
  revenueField,
  netNdp,
}: Omit<IParams, 'sobField'>) => {
  const quarterFieldsToSum = quarters.map((quarter) =>
    getActualsCYQNetNdpField({
      field: revenueField,
      quarter,
      netNdp,
    })
  )

  const allActuals = data.map((record) => {
    const actuals = quarterFieldsToSum.map(
      (revenueField) => (record as any)[revenueField] as Nullable<number>
    )

    return getSumOfNumbers(actuals)
  })

  return getSumOfNumbers(allActuals)
}

export const calculateRevenueForPeriod = ({
  data,
  quarters,
  netNdp,
  revenueField,
  sobField,
}: IParams): Nullable<number> => {
  const quarterFieldsToSum = quarters.map((quarter) => ({
    revenueField: getActualsCYQNetNdpField({
      field: revenueField,
      quarter,
      netNdp,
    }),
    sobField: getSobQField({ field: sobField, quarter }),
  }))

  const allRevenues = data.map((record) => {
    // collecting all revues
    const recordRevenuesForPeriod = quarterFieldsToSum.map<Nullable<number>>(
      ({ revenueField, sobField }) => {
        const revenue = ((record as any)[revenueField] ?? null) as Nullable<number>
        const sob = ((record as any)[sobField] ?? null) as Nullable<number>

        // P360-5808
        const hasPositiveSob = !!sob && sob > 0
        const hasPositiveRevenue = !!revenue && revenue > 0

        if (hasPositiveSob && hasPositiveRevenue) {
          return revenue
        }

        return null
      }
    )

    return getSumOfNumbers(recordRevenuesForPeriod)
  })

  return getSumOfNumbers(allRevenues)
}
